import _ from 'lodash'
import { getEmailMatches } from './urls-to-links'
import { createEmailLink } from './urls-to-links'

/**
 * Returns the given URL or email, adding a proper protocol if necessary
 */
export default function (val) {
	let emailMatches = getEmailMatches(val)

	// #28860 Allow mailto links, so we check for emails first.
	if (!_.isEmpty(emailMatches)) {
		return createEmailLink(emailMatches[0])
	} else if (val && val.indexOf('://') === -1) {
		// #15998 if the URL doesn't contain protocol, try HTTP.  I
		// considered HTTPS, but HTTP is what Chrome automatically adds
		// as of 2/15/2018
		return 'http://' + val
	}

	return val
}
